class LoadMore extends HTMLElement {
  constructor() {
    super();
    this.loadMoreBtn = this.querySelector(".button.load-more");
    this.totalPromotions = parseInt(this.dataset.totalPromotions); // 3
    this.promotionsPerPage = parseInt(this.dataset.promotionsPerPage); // 2
    this.loadMoreBtn.addEventListener("click", (event) => {
      event.preventDefault();
      this.loadMoreBtn.classList.add("loading");
      this.loadMoreBtn
        .querySelector(".loading-overlay__spinner")
        .classList.remove("hidden");
      this.loadMoreProducts();
    });
    //document.querySelector('#ProductCount > span').innerHTML = document.querySelectorAll('.grid__item').length;
  }
  uuidv4() {
  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
    (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
  );
}
  removeURLParameter(url, parameter) {
    //prefer to use l.search if you have a location/link object
    var urlparts = url.split('?');   
    if (urlparts.length >= 2) {

        var prefix = encodeURIComponent(parameter) + '=';
        var pars = urlparts[1].split(/[&;]/g);

        //reverse iteration as may be destructive
        for (var i = pars.length; i-- > 0;) {    
            //idiom for string.startsWith
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {  
                pars.splice(i, 1);
            }
        }

        return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
    }
    return url;
}
  loadMoreProducts() {
    const totalPages = parseInt(this.querySelector("[total-pages]").value);
    let nextUrl = this.querySelector("[next-url]");
    let nextPage = this.querySelector("[next-page]");
    const nextPageNum = parseInt(nextPage.value);

    if (nextPageNum <= totalPages) {
      var myHeaders = new Headers();
        myHeaders.append('pragma', 'no-cache');
        myHeaders.append('cache-control', 'no-cache');
        
        var myInit = {
          method: 'GET',
          headers: myHeaders,
        };
      fetch(this.removeURLParameter(nextUrl.value,'phcursor'), myHeaders)
        .then((response) => {
          return response.text();
        })
        .then((html) => {
          const productsInnerHTML = new DOMParser()
            .parseFromString(html, "text/html")
            .querySelectorAll("#product-grid .grid__item");
          this.renderProducts(productsInnerHTML);
          const currentParamPage = "page=" + nextPageNum;
          const nextParamPage = "page=" + (nextPageNum + 1);
          nextUrl.value = nextUrl.value.replace(
            currentParamPage,
            nextParamPage
          );
          nextPage.value = nextPageNum + 1;
        })
        .finally(() => {
          const hiddenProducts = parseInt(this.dataset.hiddenProducts);
          if (nextPageNum === totalPages) {
            this.loadMoreBtn.style.display = "none";
            if (!!hiddenProducts)
              this.parentElement.previousElementSibling.querySelector(
                "#product-grid"
              ).className = this.parentElement.previousElementSibling
                .querySelector("#product-grid")
                .className.replace(/\hide-products.*?\b/g, "");
          } else {
            this.loadMoreBtn.classList.remove("loading");
            this.loadMoreBtn
              .querySelector(".loading-overlay__spinner")
              .classList.add("hidden");
 
            if (!!hiddenProducts) {
              const updateHiddenProducts =
                hiddenProducts + (this.totalPromotions - hiddenProducts); //3
               
              if (updateHiddenProducts <= this.totalPromotions) {
                this.dataset.hiddenProducts = updateHiddenProducts;
                this.parentElement.previousElementSibling.querySelector(
                  "#product-grid"
                ).className = this.parentElement.previousElementSibling
                  .querySelector("#product-grid")
                  .className.replace(
                    /\hide-products.*?\b/g,
                    "hide-products__" + updateHiddenProducts
                  );
              }
            }

            
          }

          let itemsShow = this.parentElement.previousElementSibling
                  .querySelectorAll("#product-grid .grid__item").length - this.dataset.hiddenProducts;
          
          //console.log('Hidden products: ' + this.dataset.hiddenProducts);
          //console.log('Items Count: ' + itemsShow);
          
          //document.querySelector('#ProductCount > span').innerHTML = itemsShow;
          yotpo.refreshWidgets(); // refresh reviews for newly loaded products
          hoverVideoPlayEvents(document);
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  renderProducts(productsInnerHTML) {
    const productContainer = document.querySelector("#product-grid");
    productsInnerHTML.forEach((product) =>
      productContainer.appendChild(product)
    );
  }
}
customElements.define("load-more", LoadMore);
